/**
 * The `ch-grid-rowset-empty` component represents a container to "empty message" when ch-grid-rowset is empty.
 * @deprecated Use `ch-tabular-grid` component instead. Use `ch-tabular-grid-rowset-empty` instead.
 */
export class ChGridRowsetEmpty {
    static get is() { return "ch-grid-rowset-empty"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-rowset-empty.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-rowset-empty.css"]
        };
    }
}
